import { create } from 'zustand';
import { EVERYTHING_CONTEXT } from '../constants.js';
import equal from '../../../node_modules/fast-deep-equal/es6/react.js';
import { useEffect } from 'react';

const initialMessages = [];
const initialState = {
  actionInit: void 0,
  chatAssistantOpen: false,
  chatAssistantFullscreen: false,
  lastContextSubtype: null,
  assistantSelectedIds: [],
  hydratedKey: void 0,
  messages: initialMessages,
  activeContext: EVERYTHING_CONTEXT,
  forceHideAssistantButton: false
};
const useAssistantStore = create()((set) => ({
  ...initialState,
  setForceHideAssistantButton: (forceHideAssistantButton) => set({
    forceHideAssistantButton
  }),
  setActionInit: (actionInit) => set({
    actionInit
  }),
  setLastContextSubtype: (contextSubtype) => set({
    lastContextSubtype: contextSubtype
  }),
  setChatAssistantOpen: (open) => set((prevState) => ({
    ...prevState,
    chatAssistantOpen: open,
    chatAssistantFullscreen: open ? prevState.chatAssistantFullscreen : false
  })),
  setChatAssistantFullscreen: (open) => set({
    chatAssistantFullscreen: open
  }),
  setMessages: (param) => {
    typeof param === "function" ? set((state) => ({
      messages: param(state.messages)
    })) : set({
      messages: param
    });
  },
  addMessage: (message) => {
    set((state) => {
      if (message.type === "context-switch-info") {
        let currentMessages = state.messages;
        if (currentMessages[currentMessages.length - 1]?.type === "context-switch-info" && message.type === "context-switch-info") {
          currentMessages = currentMessages.slice(0, -1);
        }
        const lastMessage = currentMessages[currentMessages.length - 1];
        if (lastMessage && lastMessage.context?.subType === message.context?.subType && equal(lastMessage.context?.value, message.context?.value)) {
          return {
            messages: currentMessages
          };
        }
        return {
          messages: [
            ...currentMessages,
            message
          ]
        };
      } else {
        return {
          messages: [
            ...state.messages,
            message
          ]
        };
      }
    });
  },
  setAssistantSelectedIds: (ids) => set({
    assistantSelectedIds: ids
  }),
  setHydratedKey: (key) => set({
    hydratedKey: key
  }),
  reset: () => set(initialState),
  setActiveContext: (arg) => {
    set((state) => ({
      activeContext: typeof arg === "function" ? arg(state.activeContext) : arg
    }));
  }
}));
const useHideAssistantStore = (hide) => {
  useEffect(() => {
    useAssistantStore.getState().setForceHideAssistantButton(hide);
    return () => {
      useAssistantStore.getState().setForceHideAssistantButton(false);
    };
  }, [
    hide
  ]);
};

export { useAssistantStore, useHideAssistantStore };
//# sourceMappingURL=assistantStore.js.map
